import { FunctionComponent, memo } from "react";

import { IProps } from "./anomaly-title.types";
import "./anomaly-title.scss";

/**
 * Render a title for an anomaly.
 * @param props.displayName The name of the anomaly to display.
 */
const AnomalyTitle: FunctionComponent<IProps> = ({ displayName }) => {
    return <h3 className="anomaly-title">{displayName}</h3>;
};

export default memo(AnomalyTitle);
